module.exports = __webpack_public_path__ + "static/img/pay-9.5381f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-9.jpg
// module id = Lzld
// module chunks = 1